import React, {PureComponent, ReactNode} from "react"
import {DocumentNode} from "graphql"
import {QueryResult} from "react-apollo"

import {Query, pagination} from "@irati/utils/services/apollo"
import {DealLocation} from "@irati/types"

import DealLocationQuery from "../../services/queries/DealLocations"

export interface LocationVariables {
  lat: number,
  lng: number,
  dealId: string,
  limit: number,
  offset: number,
  radius: number
}

export interface LocationData {
  dealLocations: {
    results: DealLocation[]
  }
}

interface Props {
  children: (result: DealLocationsResult) => ReactNode,
  variables: LocationVariables,
  query?: DocumentNode,
  notifyOnNetworkStatusChange?: boolean
}

export interface DealLocationsResult extends QueryResult<LocationData, LocationVariables> {
  fetchMore: (variables: any) => any,
  data: LocationData
}

export const query = DealLocationQuery

class DealLocationsQueryComponent extends PureComponent<Props> {
  static defaultProps = {
    query,
    notifyOnNetworkStatusChange: true
  }

  render() {
    const {children} = this.props
    return (
      <Query {...this.props}>
        {(apolloState: DealLocationsResult) => {
          const fetchMore = (variables: LocationVariables) =>
            pagination(
              {
                query,
                variables
              },
              apolloState
            )
          return children({...apolloState, fetchMore})
        }}
      </Query>
    )
  }
}

export default DealLocationsQueryComponent
